import {
  addControlsHandler
} from './count';
import {
  dialog
} from '../base';

export function handlers() {
  addControlsHandler();
  dialog.init();
}
